module.exports = __webpack_public_path__ + "static/media/PM3.40e1449b.png";